<nav #navbar class="navbar navbar-expand-lg navbar-sakai">
    <div class="container-fluid">
        <button mat-button class="navbar-toggler btn-no-ripple" type="button" (click)="sidebarToggle()">
            <span class="sr-only">Toggle navigation</span>
            <span class="navbar-toggler-icon icon-bar"></span>
            <span class="navbar-toggler-icon icon-bar"></span>
            <span class="navbar-toggler-icon icon-bar"></span>
        </button>
        <div class="navbar-wrapper">
            <div class="navbar-minimize" style=" display:flex; gap:15px;">
                <button mat-raised-button (click)="minimizeSidebar()" class="btn btn-just-icon btn-white btn-fab btn-round sidebar-toggle-btn"
                        matTooltip="{{'NavBar.ToggleSidebar' | translate}}" aria-label="Toggle sidebar">
                    <i class="material-icons">menu</i>
                </button>
                <button mat-raised-button (click)="backClicked()" class="btn btn-just-icon btn-white btn-fab btn-round"
                        matTooltip="{{'NavBar.Back' | translate}}" aria-label="Back Button">
                <mat-icon>arrow_back</mat-icon>
                </button>
            </div>
            <a class="navbar-brand" href="{{getPath()}}"> {{AppService.TitlePage | translate}}</a>
        </div>
        <div class="collapse navbar-collapse justify-content-end" id="navigation">
            <ul class="navbar-nav">
                <!-- <li class="nav-item">
                    <button mat-icon-button aria-label="Notificaciones" [matMenuTriggerFor]="notification">
                        <mat-icon [matBadge]="totalNotifications" [matBadgeHidden]="totalNotifications == 0">notifications</mat-icon>
                    </button>
                    <mat-menu #notification="matMenu">
                        <button *ngIf="notifications?.length == 0" mat-menu-item style="text-align: center; margin-bottom: 0px;">{{'NavBar.No-Notifications' | translate}}</button>
                        <div *ngIf="notifications?.length > 0" style="padding: 0.8rem; display: flex; flex-flow: column; gap: 0.6rem; max-height: 400px;overflow-y: auto;">
                            <div style="display: flex; justify-content: space-between;">
                                <p style="margin: 0px; font-weight: bold; font-size: 18px;">{{'NavBar.Notifications' | translate}}</p>
                                <a style="margin: 0px; font-size: 12px; color: #9c27b0; cursor: pointer;" (click)="markNotificationsAsRead()">{{'NavBar.MarkAsRead' | translate}}</a>
                            </div>
                            <mat-divider style="border-color: #b3b3b3;"></mat-divider>
                            <div *ngFor="let notification of notifications; let last = last;">
                                <button mat-menu-item style="padding: 0.5rem; border-radius: 0.4rem; white-space: pre-line; line-height: normal; height: auto;" 
                                [ngClass]="{'notseen': notification.state == false}" (click)="markSingleNotificationsAsRead(notification.id)">
                                    <div style="display: flex; gap: 1rem; align-items: center;">
                                        <div style="display: flex; align-items: center; justify-content: center; background-color: #e6e3f5; border-radius: 50px; width: 40px; height: 40px; min-width: 40px; min-height: 40px;">
                                            <mat-icon style="margin: 0px; color: #9c27b0;">notifications</mat-icon>
                                        </div>
                                        <div>
                                            <h5 style="margin-bottom: 0px; font-size: 1rem; font-weight: 500;"> <mat-icon>notifications</mat-icon> {{notification.title | translate}} </h5>
                                            <p style="margin-bottom: 0px;">{{notification.body | translate}}: {{ notification.data }}</p>
                                            <p style="font-size: 12px; margin-bottom: 0px; margin-top: 4px; color: gray;"> {{ getTimeAgoDate(notification.sendDate)}} </p>
                                        </div>
                                    </div>
                                </button>
                                <mat-divider *ngIf="!last" style="margin: 0.6rem 5px; margin-bottom: 0px;"></mat-divider>
                            </div>
                        </div>
                        <button mat-menu-item style="text-align: center; margin-bottom: 0px;" (click)="goToNotifications()">
                            {{'NavBar.SeeAll' | translate}}
                        </button>
                    </mat-menu>
                </li> -->
                <li class="nav-item">
                  <a href="javascript:void(0)" class="nav-link" (click)="toggleDarkMode()"
                     matTooltip="{{ (isDarkMode ? 'NavBar.LightMode' : 'NavBar.DarkMode') | translate }}" aria-label="Toggle dark mode">
                    <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
                  </a>
                </li>
                <li class="nav-item dropdown">
                  <a id="colorPaletteDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="nav-link"
                     matTooltip="{{'NavBar.Theme' | translate}}" aria-label="Theme color">
                    <mat-icon>palette</mat-icon>
                  </a>
                  <div aria-labelledby="colorPaletteDropdown" class="dropdown-menu dropdown-menu-right color-palette-panel">
                    <span class="color-palette-title">{{'NavBar.PrimaryColor' | translate}}</span>
                    <div class="color-palette-swatches">
                      <span *ngFor="let color of paletteColors"
                            class="color-swatch"
                            [class.active]="selectedAccentColor === color.key"
                            [style.background-color]="color.hex"
                            [title]="color.key"
                            (click)="selectAccentColor(color.key)">
                      </span>
                    </div>
                    <span class="color-palette-title">{{'NavBar.Surface' | translate}}</span>
                    <div class="color-palette-swatches">
                      <span *ngFor="let tone of surfaceTones"
                            class="color-swatch"
                            [class.active]="selectedSurfaceTone === tone.key"
                            [style.background-color]="tone.hex"
                            [title]="tone.key"
                            (click)="selectSurfaceTone(tone.key)">
                      </span>
                    </div>
                  </div>
                </li>
                <li class="nav-item dropdown show">
                  <a id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" class="nav-link">
                    <mat-icon [matBadge]="totalNotifications" [matBadgeHidden]="totalNotifications == 0">notifications</mat-icon>
                  </a>
                    <div aria-labelledby="navbarDropdownMenuLink" class="dropdown-menu dropdown-menu-right">
                      <div class="col-sm-12 p-2 d-flex justify-content-between border-bottom border-dark" style="min-width: 400px;">
                        <span class="bold">{{'NavBar.Notifications' | translate}}</span>
                        <span class="text-primary" (click)="markNotificationsAsRead()" class="text_click">{{'NavBar.MarkAsRead' | translate}}</span>
                      </div>
                                            <div style="overflow-y: scroll; height: 150px;">
                                                <a *ngFor="let notification of notifications;" (click)="markSingleNotificationsAsRead(notification,true)" class="dropdown-item d-flex flex-column px-2 m-0 border-bottom">
                                                    <div class="col d-flex justify-content-between px-0">
                                                        <span class="bold"><span><mat-icon>receipt_long</mat-icon></span>  {{notification.title | translate}} </span>
                                                        <span style="text-align: right; font-size: 12px; color: gray;">
                                                            {{ getTimeAgoDate(notification.sendDate)}}
                                                            <mat-icon style="font-size: 13pt;">open_in_new</mat-icon>
                                                        </span>
                                                    </div>
                                                    {{notification.body | translate}}
                                                </a>
                                            </div>
                      <div class="col-sm-12 p-1 text-center border-top border-dark">
                        <span class="text-primary" (click)="goToNotifications()" class="text_click">   {{'NavBar.SeeAll' | translate}}</span>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown">
                    <a style="margin-left: 0px; display: flex; flex-direction: row; align-items: center; gap: 15px;" class="nav-link" href="#" id="navbarDropdownMenuLink2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img *ngIf="userAvatarUrl" [src]="userAvatarUrl" alt="avatar" class="avatar-navbar">
                        <img *ngIf="!userAvatarUrl" src="../../../../assets/img/default-avatar.png" style="border: solid 1px darkgray;" alt="avatar" class="avatar-navbar">
                        <a>{{ userName }}</a>
                    </a>
                    
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink2" style="width: 100%; text-align: center;">
                        <a class="dropdown-item" style="cursor: pointer;" (click)="changePassword()">{{'Change-Password.Title' | translate}}</a>
                        <a class="dropdown-item" style="cursor: pointer;" (click)="changeTressPassword()">{{'Change-Password.TressTitle' | translate}}</a>
                        <!-- <a class="dropdown-item" style="cursor: pointer;" (click)="goToSettings()">{{'NavBar.Config' | translate}}</a> -->
                        <a class="dropdown-item" style="cursor: pointer;" (click)="logout()">{{ 'NavBar.SignOut' | translate }}</a>
                    </div>
                </li>
            </ul>
        </div>

    </div>

</nav>

<br />
